import { Toast } from "@heroui/react";
import { useEffect } from "react";
import { useResolvedColorScheme } from "@/src/common/hooks/use-resolved-color-scheme";

export function AppThemeProvider({ children }: { children: React.ReactNode }) {
	const resolvedScheme = useResolvedColorScheme();

	useEffect(() => {
		const root = document.documentElement;
		root.classList.remove("light", "dark");
		root.classList.add(resolvedScheme);
		root.setAttribute("data-theme", resolvedScheme);
	}, [resolvedScheme]);

	return (
		<>
			{children}
			<Toast.Provider />
		</>
	);
}
